/**
 * @author zk
 * @description 记录用户页面配置
 * @Date 2019/12/28
 */
import React from 'react'
import { component_tool, framework_tool } from '@/tool';
import { Divider } from "antd";
let { WizModal } = component_tool;

//配置项
let componentName = 'syncTimsTransfer'
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "转换目标",
    name: "sourceCode",
    searchItem: {},
    tableItem: {
      width: 150
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入转换目标'
      }],
    },
  },
  {
    title: "业务类型",
    name: "bizType",
    searchItem: {
      type: 'select'
    },
    tableItem: {
    },
    formItem: {
      type: "select",
      //   initialValue:  0,
      rules: [
        {
          required: true,
          message: '请选择业务类型'
        },
      ],
    },
    dict: [
      { code: 0, codeName: "课程" },
      { code: 8, codeName: "主题" },
    ],
  },
  {
    title: "筛选条件",
    name: "condition",
    formItem: {
      initialValue: "",
      rules: [
        {
          required: true,
          message: '请输入筛选条件'
        },
        { pattern: /^[ %()andors]+$/, message: '筛选条件只能包含空格，and，or，(,),%s' },
      ],
    },
  },
  {
    title: "参数",
    name: "parameter",
    tableItem: {
    },
     formItem: {
      initialValue: "",
      rules: [
        {
          required: true,
          message: '请输入参数'
        },
      ],
    },
    }
  ,
];
const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort: ['add', 'delete'],
      },
      rowOperateSort: ['update'],
      // rowOperateProps: {
      //   width: 120,
      //   fixed: 'right',
      // },
      rowOperateView: [
      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },

  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  // export: {
  //   path: `${componentName}/export`,
  //   payload: {
  //     key: `${componentName}@export`,
  //     apiParams: {}
  //   }
  // }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
